/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";
import Dropdown from "./dropdown";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const Th = ({ children, styles, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...styles, fontSize: "14px " }}>
      {children}
    </th>
  );
};

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
  {
    value: "Cục thuế Cần thơ",
    label: "Cục thuế Cần thơ",
  },
  {
    value: "Cục thuế Hà nội",
    label: "Cục thuế Hà nội",
  },
];

const partOption = [
  {
    value: "Thuế thu nhập từ tiền lương, tiền công",
    label: "Thuế thu nhập từ tiền lương, tiền công",
  },
  {
    value: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
    label: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
  },
  {
    value: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
    label: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
  },
  {
    value: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
    label: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
  },
  {
    value:
      "Thuế thu nhập từ chuyển nhượng bất động sản nhận thừa kế và nhận quà tặng là bất động sản",
    label:
      "Thuế thu nhập từ chuyển nhượng bất động sản nhận thừa kế và nhận quà tặng là bất động sản",
  },
];
const provinceOption = [
  {
    value: "An giang",
    label: "An giang",
  },
  {
    value: "Cần thơ",
    label: "Cần thơ",
  },
  {
    value: "TP Hồ Chí Minh",
    label: "TP Hồ Chí Minh",
  },
];
const districtOption = [
  {
    value: "Châu thành",
    label: "Châu thành",
  },
  {
    value: "Long xuyên",
    label: "Long xuyên",
  },
  {
    value: "Chợ mới",
    label: "Chợ mới",
  },
];
const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    taxID: {
      type: "input",
      value: "",
      bg: false,
    },
    payerName: {
      type: "input",
      value: "",
      bg: false,
    },
    debtContent: {
      type: "input",
      value: "",
      bg: true,
    },
    chapter: {
      type: "input",
      value: "",
      bg: false,
    },
    part: {
      type: "select",
      value: "",
      bg: false,
      option: partOption,
    },
    identifierID: {
      type: "input",
      value: "",
      bg: false,
    },

    taxAuthoritiesProvince: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    taxAuthoritiesDistrict: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    province: {
      type: "select",
      value: null,
      bg: false,
      option: provinceOption,
    },
    district: {
      type: "select",
      value: null,
      bg: false,
      option: districtOption,
    },
    deadline: {
      type: "input",
      value: "",
      bg: false,
    },
    amountType: {
      type: "input",
      value: "VNĐ",
      bg: true,
    },
    amountMustPaid: {
      type: "input",
      value: 0,
      bg: false,
    },
    proposedPaymentAmount: {
      type: "input",
      value: 0,
      bg: false,
    },
    amountMustPaidAfter: {
      type: "input",
      value: 0,
      bg: false,
    },
  },
];

export default function PaidAmountTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesRefundRequestTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" flexDirection={"column"} justifyContent="flex-start">
        <Typography component="label" variant="caption" fontSize={14} fontWeight="bold" mb={0.5}>
          III - ĐỀ NGHỊ XỬ LÝ KHOẢN NỘP THỪA
        </Typography>
        <Typography variant="subtitle1" fontSize={13} fontStyle="normal">
          1. thông tin người nộp thuế đề nghị bù trừ khoản nộp thừa với khoản nợ, khoản thu phát
          sinh hoặc đề nghị hoàn kiêm bù trừ thu ngân sách nhà nước
        </Typography>
      </Box>
      <div
        style={{
          overflowX: "auto",
          // overflowY: "hidden",
          width: "100%",
          padding: "10px 5px",
        }}
      >
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Td rowSpan={3} style={{ textAlign: "center" }}>
                  STT
                </Td>
                <Td colSpan={13} style={{ textAlign: "center" }}>
                  Thông tin khoản nợ/Khoản thu phát sinh
                </Td>
                <Td rowSpan={3} style={{ textAlign: "center", width: "100px" }}>
                  Số tiền còn phải nộp đề nghị bù trừ với số tiền nộp thừa
                </Td>
                <Td rowSpan={3} style={{ textAlign: "center", width: "20%" }}>
                  Số tiền còn phải nộp đề sau bù trừ
                </Td>
              </tr>
              <tr>
                <Td rowSpan={2} style={{ textAlign: "center" }}>
                  MST của NNT khác (Nếu có)
                </Td>
                <Td rowSpan={2} style={{ textAlign: "center" }}>
                  Tên người nộp thuế khác (Nếu có)
                </Td>
                <Td rowSpan={2} style={{ textAlign: "center" }}>
                  Nội dung khoản nợ/phát sinh
                </Td>

                <Td rowSpan={2} style={{ textAlign: "center" }}>
                  Mã định danh khoản phải nộp (ID) (Nếu có)
                </Td>
                <Td rowSpan={2} style={{ textAlign: "center" }}>
                  Chương
                </Td>
                <Td rowSpan={2} style={{ textAlign: "center", width: "20%" }}>
                  Tiểu mục
                </Td>
                <Td colSpan={2} style={{ textAlign: "center", width: "20%" }}>
                  Tên cơ quan thu
                </Td>
                <Td colSpan={2} style={{ textAlign: "center", width: "20%" }}>
                  Địa bàn hành chính
                </Td>
                <Td rowSpan={2} style={{ textAlign: "center" }}>
                  Hạn nộp
                </Td>
                <Td rowSpan={2} style={{ textAlign: "center", width: "10px" }}>
                  Loại tiền
                </Td>
                <Td rowSpan={2} style={{ textAlign: "center" }}>
                  Số tiền còn phải nộp
                </Td>
              </tr>
              <tr>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  Cơ quan thuế cấp cục
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  Cơ quan thuế cấp chi cục
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  Tỉnh
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  Huyện
                </Td>
              </tr>
              <tr>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (1)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (2)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (3)
                </Td>
                <Td rowSpan={2} style={{ textAlign: "center" }}>
                  (4)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (5)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (6)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (7)
                </Td>
                <Td colSpan={2} style={{ textAlign: "center" }}>
                  (8)
                </Td>
                <Td colSpan={2} style={{ textAlign: "center" }}>
                  (9)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (10)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (11)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (12)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (13)
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  (14)=(12)-(13)
                </Td>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((row, index) => (
                  <tr key={row.id.value}>
                    <Td
                      row={""}
                      style={{
                        textAlign: "center",
                        background: "#fff",
                      }}
                    >
                      {index + 1}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.taxID.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.taxID?.type !== "input" ? (
                        row.taxID.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="taxID"
                          value={row.taxID.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.payerName.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.payerName?.type !== "input" ? (
                        row.payerName.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="payerName"
                          value={row.payerName.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.debtContent.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.debtContent?.type !== "input" ? (
                        row.debtContent.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="debtContent"
                          value={row.debtContent.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.identifierID.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.identifierID?.type !== "input" ? (
                        row.identifierID.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="identifierID"
                          value={row.identifierID.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.chapter.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.chapter?.type !== "input" ? (
                        row.chapter.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="chapter"
                          value={row.chapter.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.part.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.part?.type !== "select" ? (
                        row.part.value
                      ) : (
                        <SelectTable
                          name="part"
                          id={row.id.value}
                          option={row.part.option ? row.part.option : defaultOption}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.taxAuthoritiesProvince.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.taxAuthoritiesProvince?.type !== "select" ? (
                        row.taxAuthoritiesProvince.value
                      ) : (
                        <SelectTable
                          name="taxAuthoritiesProvince"
                          id={row.id.value}
                          option={
                            row.taxAuthoritiesProvince.option
                              ? row.taxAuthoritiesProvince.option
                              : defaultOption
                          }
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.taxAuthoritiesDistrict.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.taxAuthoritiesDistrict?.type !== "select" ? (
                        row.taxAuthoritiesDistrict.value
                      ) : (
                        <SelectTable
                          name="taxAuthoritiesDistrict"
                          id={row.id.value}
                          option={
                            row.taxAuthoritiesDistrict.option
                              ? row.taxAuthoritiesDistrict.option
                              : defaultOption
                          }
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.province.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.province?.type !== "select" ? (
                        row.province.value
                      ) : (
                        <SelectTable
                          name="province"
                          id={row.id.value}
                          option={row.province.option ? row.province.option : defaultOption}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.district.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.district?.type !== "select" ? (
                        row.district.value
                      ) : (
                        <SelectTable
                          name="district"
                          id={row.id.value}
                          option={row.district.option ? row.district.option : defaultOption}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.deadline.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.deadline?.type !== "input" ? (
                        row.deadline.value
                      ) : (
                        <InputTable
                          fields={"date"}
                          type={"text"}
                          id={row.id.value}
                          name="deadline"
                          value={row.deadline.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.amountType.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.amountType?.type !== "input" ? (
                        row.amountType.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="amountType"
                          value={row.amountType.value}
                          onChange={handleChange}
                          style={{
                            background: "none",
                            fontSize: "13px",
                            textAlign: "center",
                            outLine: "none",
                            border: "none",
                          }}
                          readOnly={true}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.amountMustPaid.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.amountMustPaid?.type !== "input" ? (
                        row.amountMustPaid.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="amountMustPaid"
                          value={row.amountMustPaid.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.proposedPaymentAmount.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.proposedPaymentAmount?.type !== "input" ? (
                        row.proposedPaymentAmount.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="proposedPaymentAmount"
                          value={row.proposedPaymentAmount.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.amountMustPaidAfter.bg ? "transparent" : "#ddeff3",
                        width: "100px",
                      }}
                    >
                      {row.amountMustPaidAfter?.type !== "input" ? (
                        row.amountMustPaidAfter.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="amountMustPaidAfter"
                          value={row.amountMustPaidAfter.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                  </tr>
                ))}

              <tr>
                <Td
                  colspan="12"
                  row={{ bold: true }}
                  style={{
                    textAlign: "left",
                    background: "#ddeff3",
                  }}
                >
                  Tổng cộng theo tiểu mục:
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
              </tr>

              <tr>
                <Td
                  colspan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "left",
                    background: "#ddeff3",
                  }}
                >
                  1
                </Td>
                <Td
                  colspan="11"
                  row={{ bold: true }}
                  style={{
                    textAlign: "left",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
              </tr>
              <tr>
                <Td
                  colspan="12"
                  row={{ bold: true }}
                  style={{
                    textAlign: "left",
                    background: "#ddeff3",
                  }}
                >
                  Tổng cộng:
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
              </tr>
            </tbody>
          </table>
          {/* <Footer formData={formData} /> */}
        </Box>
      </div>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    console.log(type);
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={fields ? fields : "text"}
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
